export default {
  title: "Secrets & Intégrations",
  subtitle:
    "Clés d'API et secrets partagés entre modules. Valeurs chiffrées AES-256-GCM au repos; jamais retournées en clair par l'API.",
  createCta: "Créer un secret",
  createTitle: "Nouveau secret",
  createDescription:
    "Le nom identifie le secret dans les templates; le type de connecteur sert à filtrer par consommateur.",
  filterPlaceholder: "Filtrer par type",
  allConnectors: "Tous les connecteurs",
  empty: "Aucun secret pour ce connecteur.",
  created: "Secret créé.",
  createFailed: "Échec de la création.",
  fetchFailed: "Impossible de charger la liste des secrets.",
  revoke: "Révoquer",
  revoked: "Secret révoqué.",
  revokeFailed: "Échec de la révocation.",
  revokeTitle: "Révoquer ce secret ?",
  revokeMessage:
    "« {name} » ne pourra plus être utilisé par les connecteurs. La ligne reste visible comme révoquée.",
  deleted: "Secret supprimé.",
  deleteFailed: "Échec de la suppression.",
  deleteTitle: "Supprimer ce secret ?",
  deleteMessage:
    "« {name} » sera définitivement supprimé. Cette action est irréversible.",
  nameLabel: "Nom technique",
  connectorLabel: "Type de connecteur",
  valueLabel: "Valeur",
  descriptionLabel: "Description",
  descriptionPlaceholder: "Optionnel. Ex. « LRE prod AR24 »",
  columns: {
    name: "Nom",
    connector: "Connecteur",
    description: "Description",
    status: "Statut",
    updated: "Mis à jour",
    actions: "",
  },
  connectors: {
    lre_api: "LRE (lettre recommandée)",
    smtp: "SMTP",
    openai: "OpenAI",
    jira: "Jira",
    notion: "Notion",
    other: "Autre",
  },
  picker: {
    loading: "Chargement…",
    createCta: "Créer un nouveau secret",
    cancel: "Annuler",
    save: "Enregistrer le secret",
    nameLabel: "Nom",
    descriptionLabel: "Description (optionnel)",
    docsHint: "Pas encore de clé ?",
    docsLink: "Obtenir votre {label}",
    usedBy: "Utilisé par {count} agent",
    usedByPlural: "Utilisé par {count} agents",
    generateCta: "Générer une valeur aléatoire forte",
    generateHint:
      'Ou cliquez sur "Générer" ci-dessus pour que le serveur produise une valeur cryptographiquement forte.',
    revealTitle: "Secret créé — copiez-le maintenant",
    revealBody:
      "Cette valeur ne s'affiche qu'une seule fois. Après fermeture de ce panneau, elle ne pourra plus être récupérée.",
    revealValueLabel: "Valeur générée",
    revealDismiss: "Je l'ai copiée",
    copy: "Copier dans le presse-papiers",
  },
};
